module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.b81656fa.svg";